'use client'

import React, { useId } from 'react'

/**
 * Hidden field that only a bot fills in. /api/newsletter/subscribe treats any
 * value in it as a bot signal and subscribes nothing (see src/lib/formGuard.ts).
 * Every form driven by useNewsletterSubscribe renders this, so the check cannot
 * drift form by form.
 *
 * Not display:none and not type="hidden": some bots skip both. Moved off-screen
 * instead, out of the tab order and hidden from screen readers.
 */
export const HoneypotField: React.FC<{
  value: string
  onChange: (value: string) => void
}> = ({ value, onChange }) => {
  const id = useId()

  return (
    <div className="absolute -left-[9999px] top-auto h-px w-px overflow-hidden" aria-hidden>
      <label htmlFor={id}>Fax</label>
      <input
        id={id}
        name="fax"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
